import React from 'react';
import api from '../../services/api';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import Snackbar from 'material-ui/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import Back from 'material-ui/svg-icons/hardware/keyboard-backspace';
import Calendar from 'material-ui/svg-icons/action/event';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Toggle from 'material-ui/Toggle';
import { Step, Stepper, StepLabel } from 'material-ui/Stepper';
import { blue200 } from 'material-ui/styles/colors';
import LinearProgress from 'material-ui/LinearProgress';
import './Active.css';

class Active extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      type: "count",
      period: "Year",
      year: null,
      month: null,
      openHint: false,
      stepIndex: null,
      paddingStepper: "0px"
    };
  }
  componentDidMount() {
    var self = this;
    this.updateData();
    setTimeout(function () { self.setState({ openHint: true }); }, 2000);
  }
  componentDidUpdate(prevProps, nextState) {
    if (this.state.type != nextState.type) this.updateData();
    if (this.state.period != nextState.period) this.updateData();
    if (this.state.year != nextState.year) this.updateData();
    if (this.state.month != nextState.month) this.updateData();
  }
  updateData() {
    var self = this;
    this.setState({ stepIndex: null });
    api.getActiveReport(this.state.type, this.state.period, this.state.year, this.state.month).then((rs) => {
      this.state.stepIndex = this.state.period == "Year" ? 0 : this.state.period == "Month" ? 1 : 2;
      var aux = [];
      Object.keys(rs.response).forEach(function (key) {
        if (self.state.period == "Year") {
          if (rs.response[key] > 0)
            aux.push({ period: key, count: rs.response[key] });
        } else aux.push({ period: key, count: rs.response[key], "Mês": key });
      });
      this.setState({ data: aux });
    }).catch((error) => {
      console.error(error);
    });
  }
  changePeriod = (data, index) => {
    if (this.state.period == "Year") {
      this.setState({ stepIndex: 1 });
      this.setState({ year: data.period });
      this.setState({ period: "Month" });
    }
    if (this.state.period == "Month") {
      this.setState({ stepIndex: 2 });
      this.setState({ month: data.period });
      this.setState({ period: "Day" });
    }
  };
  changeType = (event, isInputChecked) => {
    var type = isInputChecked ? "sum" : "count";
    this.setState({ type: type });
  };
  handleBack = (event) => {
    if (this.state.period == "Month") {
      this.setState({ period: "Year" });
      this.setState({ stepIndex: 0 });
    }
    if (this.state.period == "Day") {
      this.setState({ period: "Month" });
      this.setState({ stepIndex: 1 });
    }
  };
  getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return <p className="status-message">Alumni ativos por ano.</p>
      case 1:
        return <p className="status-message">Alumni ativos por mês no ano  {this.state.year}.</p>
      case 2:
        return <p className="status-message">Alumni ativos por dia no mês  {this.state.month}/{this.state.year}</p>
      default:
        return <div><p className="status-message">Carregando dados... </p><LinearProgress mode="indeterminate" style={{ margin: "auto", width: "50%" }} /></div>;
    }
  }
  render() {
    const { stepIndex } = this.state;    
    var period = this.state.period;
    var data = this.state.data;
    return (
      <div>
        <div className="active-main">
          <h1>Alumni ativos </h1>
          <div className={period == "Year" ? "" : "timeline-divided"}>
            <div>
              <Stepper activeStep={stepIndex}>
                <Step>
                  <StepLabel >Ano</StepLabel>
                </Step>
                <Step>
                  <StepLabel >Mês</StepLabel>
                </Step>
                <Step>
                  <StepLabel >Dia</StepLabel>
                </Step>
              </Stepper>
            </div>
            {this.state.period == "Year" ? null :
              <div>
                <FloatingActionButton onClick={this.handleBack} >
                  <Back />
                </FloatingActionButton>
              </div>
            }
          </div>

          <div >            
            {this.getStepContent(stepIndex)}            
          </div>
          <div className="main-button-acumulated">
            <div className="button-acumulated">
              <Toggle
                onToggle={this.changeType}
                label="Acumulado"
              />
            </div>
          </div>          
          <div style={{height: "600px"}}>            
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={this.state.data} margin={{ top: 25, right: 0, left: 0, bottom: 5 }}>
                <XAxis dataKey="period" />
                <YAxis />
                <CartesianGrid strokeDasharray="3 3" />
                <Tooltip />
                <Legend />
                <Bar onClick={this.changePeriod} name="# Alumni ativos" dataKey='count' fill='orange' />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <Snackbar
          open={this.state.openHint}
          message="Clique nas barras do gráfico para navegar entre os dados."
          autoHideDuration={10000} />
      </div>

    )
  }
};
export default Active;


// WEBPACK FOOTER //
// ./src/pages/reports/Active.js